/**
 * Did the server actually answer?
 *
 * Not the same as "does `error.response` exist". With NO network (offline, DNS failure, blocked host) axios 0.27 puts the
 * XMLHttpRequest itself in `error.response`: it is truthy, but status is 0 and there is no body. Reading that as "the server
 * answered" made the sign-in retry give up and the page blame the server (DW-026). A real answer has a status of 100 or more.
 */
export const hasServerAnswer = (error: any): boolean => {
  const status = error?.response?.status;
  return typeof status === "number" && status > 0;
};
